import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const StarOutline = createSvgIcon(React.createElement("path", { d: "M23.3,9.5l-7.8-1.1L12,1.2L8.5,8.3L0.7,9.5L6.3,15L5,22.8l7-3.7l7,3.7L17.7,15L23.3,9.5z M12,16.8l-4.4,2.3l0.8-4.9L5,10.8l0,0l4.9-0.7L12,5.7l2.2,4.4l4.9,0.7h0l-3.5,3.4l0.8,4.9L12,16.8z", fill: "#000" }), 'StarOutline');
export default StarOutline;
